import React, { useState, useContext, useEffect } from "react";
import "./LoginPage.css";

import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { Context } from "../../../utils/context";
import LoginLottie from "./LoginLottie";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { getData } from "../../../utils/api";

const LoginPage = () => {
  const { postData, signin, setSignin, usertype, setUsertype, IMG_URL } =
    useContext(Context);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    let errors = {};

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

    if (!formData.password.trim()) {
      errors.password = "Password is required";
    }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await postData("/common/auth/admin-login", formData);

      if (response.success) {
        setSignin(response.success);
        setUsertype(response?.data?.role);

        Cookies.set("gurukrupa_admin_security", response.data?.token, {
          expires: 365,
        });

        if (response?.data?.role === "demo") {
          navigate("/demo");
        } else if (response?.data?.role?.length) {
          navigate("/advanceDashboard");
        }
      } else {
        setShowErrorModal(response);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  const [appSetup, setAppSetup] = useState({});

  const GetAppSetup = async () => {
    const response = await getData(`/common/masters/app-setup`);

    if (response?.success) {
      setAppSetup(response?.data);
    }
  };

  useEffect(() => {
    GetAppSetup();
  }, []);

  return (
    <section className="Login">
      <div className="container-fluid p-0">
        <div className="row">
          {/* LEFT SECTION */}
          <div className="col-lg-6 col-md-6 col-sm-6 Login_lottie_col">
            <LoginLottie IMG_URL={IMG_URL} appSetup={appSetup} />
          </div>

          {/* RIGHT SECTION */}
          <div className="col-lg-6 col-md-6 col-sm-12 Login_form_col">
            <div className="card text-center login-card theme_bg_secondary_colour">
              <div className="text-holder-login">
                <h2 className="text-start heading_text">Login</h2>

                <p className="text-start mt-4">
                  Hey, Enter your details to get sign in to your account
                </p>

                {showErrorModal?.success ? (
                  <></>
                ) : (
                  <span style={errorStyle}>{showErrorModal?.errors}</span>
                )}

                <form onSubmit={handleSubmit} role="form">
                  {/* EMAIL LABEL */}
                  <div className="text-start">
                    <label
                      htmlFor="exampleInputEmail1"
                      className="email_txt form-label"
                    >
                      Email ID
                    </label>
                  </div>

                  {/* EMAIL INPUT */}
                  <div className="mb-3 form-control-email">
                    <input
                      type="email"
                      className="form-control inputForm"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder="Enter Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  {errors.email && (
                    <span style={errorStyle}>{errors.email}</span>
                  )}

                  {/* PASSWORD LABEL */}
                  <div className="text-start">
                    <label
                      htmlFor="exampleInputPassword1"
                      className="email_txt form-label"
                    >
                      Password
                    </label>
                  </div>

                  {/* PASSWORD INPUT */}
                  <div className="form-control-email input-group password_section">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control inputForm"
                      id="exampleInputPassword1"
                      placeholder="Password"
                      aria-label="Password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />

                    <FontAwesomeIcon
                      icon={showPassword ? faEye : faEyeSlash}
                      className="formPasword"
                      onClick={togglePasswordVisibility}
                    />
                  </div>

                  {errors.password && (
                    <span style={errorStyle}>{errors.password}</span>
                  )}

                  <input
                    className="form-control dummy_input"
                    placeholder="dummy"
                  />

                  <button
                    type="submit"
                    className="btn sign-in-button text-center"
                  >
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginPage;
